import { createStore } from "vuex";
import {
  getModule,
  Module,
  MutationAction,
  VuexModule,
} from "vuex-module-decorators";

const operatorInfo = createStore({
  state: {
    user_id: null,
  },
  mutations: {
    setOperatorInfo(state, user_id) {
      state.user_id = user_id;
    },
  },
  actions: {},
  modules: {},
});

/**
 * ユーザー属性 Store
 */
@Module({ dynamic: true, store: operatorInfo, name: "operatorStore" })
class OperatorStore extends VuexModule {
  user_id = "";
  chain_code = "";

  get hasValue(): boolean {
    return this.user_id !== "";
  }
  /**
   * ユーザー属性値を設定
   *
   * @param store
   */
  @MutationAction({
    rawError: true,
    mutate: ["user_id", "chain_code"],
  })
  async setupValue(store: { user_id: string; chain_code: string }): Promise<
    OperatorStore & {
      user_id: string;
      chain_code: string;
    }
  > {
    return {
      ...store,
    } as OperatorStore & {
      user_id: string;
      chain_code: string;
    };
  }
}
export default getModule(OperatorStore, operatorInfo);
